// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const WrapperOption = styled.div<{ isValue: boolean }>(
  ({ isValue }) => css`
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0 8px 0 0;
    cursor: ${isValue ? 'default' : 'pointer'};
  `,
);

export const HeaderWrapper = styled.div<{
  isDark?: boolean;
  hasLine?: boolean;
}>(
  ({ theme, isDark, hasLine }) => css`
    display: flex;
    border-bottom: ${hasLine ? '1px solid' : 'none'};
    border-bottom-color: ${
      isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light
    };
    padding: 22px 33px;
  `,
);

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 20px 40px 36px;
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

export const FooterWrapper = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    padding: 20px 33px;
    gap: 40px;
    color: ${isDark ? theme.colors.white : theme.colors.base.dark};
    border-top: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.gray.lighter
    };

    ${theme.breakpoints.down('sm')} {
      gap: 16px;
    }
  `,
);

export const BeautyButton = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.base.lighter};

    :hover {
      color: ${theme.colors.primary.main};
    }
  `,
);
